export const buyers = [
  { name: 'María G.', place: 'Bogotá, Colombia', minutesAgo: 2 },
  { name: 'Dr. Andrés P.', place: 'Monterrey, México', minutesAgo: 4 },
  { name: 'Valentina R.', place: 'Santiago, Chile', minutesAgo: 1 },
  { name: 'Dr. Carlos M.', place: 'Madrid, España', minutesAgo: 6 },
  { name: 'Sofía L.', place: 'Buenos Aires, Argentina', minutesAgo: 3 },
  { name: 'Dr. Diego H.', place: 'Lima, Perú', minutesAgo: 5 },
  { name: 'Daniela F.', place: 'Quito, Ecuador', minutesAgo: 2 },
  { name: 'Dr. Luis A.', place: 'Montevideo, Uruguay', minutesAgo: 7 },
  { name: 'Gabriela S.', place: 'San José, Costa Rica', minutesAgo: 3 },
  { name: 'Dr. Ricardo V.', place: 'Santo Domingo, Rep. Dominicana', minutesAgo: 8 },
  { name: 'Ana C.', place: 'Guadalajara, México', minutesAgo: 1 },
  { name: 'Dr. Fernando T.', place: 'Asunción, Paraguay', minutesAgo: 4 },
  { name: 'Isabella N.', place: 'Ciudad de Panamá, Panamá', minutesAgo: 2 },
  { name: 'Dr. Javier O.', place: 'La Paz, Bolivia', minutesAgo: 6 },
  { name: 'Camila D.', place: 'Medellín, Colombia', minutesAgo: 3 },
  { name: 'Dr. Pablo E.', place: 'Barcelona, España', minutesAgo: 5 },
  { name: 'Lucía B.', place: 'Caracas, Venezuela', minutesAgo: 2 },
  { name: 'Dra. Paula J.', place: 'Guatemala, Guatemala', minutesAgo: 4 },
];
